import React, { useState } from "react";
import { Col, Modal, Row } from "antd";
import { ModalProps } from "antd/es/modal";
import styles from "./index.module.scss";
import PhotoDetail from "./components/PhotoDetail";
import PhotoItem from "../PhotoItem";
import { ExamPhotoItem } from "../../../../../service/exam";

interface PhotoListModalProps extends ModalProps {
    photos: ExamPhotoItem[];
}

export default function PhotoListModal({
    photos,
    ...props
}: PhotoListModalProps) {
    const [current, setCurrent] = useState("");

    return (
        <Modal
            className={styles.root}
            footer={false}
            centered
            {...props}
            style={{ opacity: 1 }}>
            <Row type="flex" gutter={[10, 10]}>
                {photos.map((item, index) => (
                    <Col key={index} span={2}>
                        <PhotoItem
                            {...item}
                            onClick={() => setCurrent(item.url)}
                        />
                    </Col>
                ))}
            </Row>
            <PhotoDetail
                visible={!!current}
                photo={current}
                onCancel={() => setCurrent("")}
            />
        </Modal>
    );
}
